var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 16.6667C24.0002 15.9314 23.4022 15.3334 22.6668 15.3334H14.6668C13.9315 15.3334 13.3335 15.9314 13.3335 16.6667V23.3334C13.3335 24.0687 13.9315 24.6667 14.6668 24.6667H22.6668C23.4022 24.6667 24.0002 24.0687 24.0002 23.3334V21.1114L26.6668 23.3334V16.6667L24.0002 18.8887V16.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video_call.f10a46af8f6e50f8ead7ae44df00de90.svg";
export { ForwardRef as ReactComponent };